import { render, staticRenderFns } from "./WizardNavigation.vue?vue&type=template&id=40c4109c&scoped=true&"
import script from "./WizardNavigation.vue?vue&type=script&lang=js&"
export * from "./WizardNavigation.vue?vue&type=script&lang=js&"
import style0 from "./WizardNavigation.vue?vue&type=style&index=0&id=40c4109c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4109c",
  null
  
)

export default component.exports